import React from "react";
import type { Training } from "../../../../api/training/Training.typed";
import { useTraining } from "../../../../contexts/api";
import { useAlert } from "../../../../contexts/app/notificationToast";

// Shared "formation en cours" mail sender used by training rows (module + fiche client).
export function useTrainingMail() {
  const { sendTrainingMail } = useTraining();
  const { showAlert } = useAlert();

  const sendTrainingInProgressMail = React.useCallback(
    async (training: Training): Promise<boolean> => {
      if (!training.ID) {
        showAlert("ID de formation manquant", "warning");

        return false;
      }

      return sendTrainingMail(training.ID, "trainingInProgress");
    },
    [sendTrainingMail, showAlert],
  );

  return { sendTrainingInProgressMail };
}
